$(function() {

  if ( $('.acd').length ) {//アコーディオン用
    $('.acd').hide(); //acdを隠す
    $('.acd__btn').click(function(){
      //クリックされたacd-btnが持っているboxnameに対応したIDを持つacdを開閉する
      $('#'+$(this).data('boxname')).animate({height: 'toggle'});
      //クリックされたacd-btnと同じboxnameを持つボタンに開クラスをつける（連動する）
      $('[data-boxname="' + $(this).data('boxname') + '"]').toggleClass('acd__btn--open');
    });
  }


// 画面内アンカースクロール(lazy対応)
  $('a[href^="#"]').click(function(e) {
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;

      $.when(
        $("html, body").animate({
          scrollTop: position
        }, 400, "swing"),
        e.preventDefault()
      ).done(function() {
        var diff = target.offset().top;
        if (diff === position) {
        } else {
          $("html, body").animate({
            scrollTop: diff
          }, 10, "swing");
        }
      });
    });
});
